import { Fragment } from "react";
import PageLayouts from "layouts/PageLayouts";
import Hero from "container/contact/Hero";
import Locations from "container/home/Locations";
import BuyProxies from "container/home/BuyProxies";

const ContactUs = () => {
    return (
        <Fragment>
            <PageLayouts title="Contact Us">
                <Hero />
                <Locations classNames="desktop:!pt-[82px] desktop:!pb-[80px] tablet:py-[64px] mt-8 phone:py-12" />
                <BuyProxies />
            </PageLayouts>
        </Fragment>
    );
};

export default ContactUs;